import * as Yup from "yup";

export const AddSanctionInitialState = {
  team: "",
  sanction: "",
  time: "",
  description: "",
};

export const AddSanctionValidationSchema = Yup.object({
  team: Yup.string().required("Este campo es requerido"),
  sanction: Yup.string().required("Este campo es requerido"),
  time: Yup.string().required("Este campo es requerido"),
  description: Yup.string().required("Este campo es requerido"),
});
